import { Alert, Typography } from '@montugroup/design-system';
import { isBeforeWeekend } from './utils';

export const getPartialStockAlertMessage = (hasStock: boolean) => {
  if (hasStock) {
    if (isBeforeWeekend()) {
      return 'In stock, estimated ready in 1 business day';
    }

    return 'In stock, estimated ready on Monday - Tuesday';
  }

  return 'Awaiting stock, estimated ready in 3-7 business days';
};

export const ShippingOptionAlertPartialStock = ({ hasStock }: { hasStock: boolean }) => {
  const alertText = getPartialStockAlertMessage(hasStock);

  return (
    <Alert
      severity={hasStock ? 'success' : 'warning'}
      data-testid="shippingOptionAlertPartialStock"
      sx={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
    >
      <Typography variant="body2">{alertText}</Typography>
    </Alert>
  );
};
